import React from 'react';
import { RF15CourseStyles } from './RF15CourseStyles';
import CourseBanner from '../../../components/courseBanner/CourseBanner';

import bannerImg from '../../../assets/images/rf15.png';
// @ts-ignore
import descriptionImage from '../../../assets/images/manWithRF15.JPG';
import {
  ak47CourseData, akCourseData, rf15Course, rf15CourseData,
} from '../../../constants';
import ProgramCost from '../../../components/programCost/ProgramCost';
import ContactForm from '../../../components/contactForm/ContactForm';
import { useAppSelector } from '../../../state/hooks';
import { translations } from '../../../i18n/translations';
import WeaponCourseProgram from '../../../components/weaponCourseProgram/WeaponCourseProgram';
import ShowTextByLetter from '../../../utils/ShowTextByLetter/ShowTextByLetter';
import { InView } from 'react-intersection-observer';
import getTranslationByLangOrUk from '../../../utils/getTranslationByLangOrUk';
import Seo from '../../../components/seo/Seo';

function RF15Course() {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <>
      <Seo />
      <RF15CourseStyles>
        <CourseBanner
          image={bannerImg}
          imageMobile={bannerImg}
          imageAlt="RF-15"
          level={translations[interfaceLanguage].weapon_course_banner_level}
        />

        <div className="courseDescriptionWrapper">
          <div className="container">
            <div className="courseDescription">
              <div className="textContainer">
                <h2>{ShowTextByLetter(getTranslationByLangOrUk(interfaceLanguage, 'rf_15_course_1'))}</h2>
                <p className="subtitle">{ShowTextByLetter(getTranslationByLangOrUk(interfaceLanguage, 'rf_15_course_2'))}</p>

                <InView className="textBase18 descriptionAnimationText" as="p" onChange={(inView, entry) => (inView ? entry.target.classList.add('active') : '')}>
                  {getTranslationByLangOrUk(interfaceLanguage, 'rf_15_course_3')}
                </InView>
              </div>

              <InView as="div" className="imageContainerAnimationWrapper" onChange={(inView, entry) => (inView ? entry.target.classList.add('active') : '')}>
                <div className="imageContainer">
                  <img src={descriptionImage} alt={getTranslationByLangOrUk(interfaceLanguage, 'rf_15_course_4')} />
                </div>
              </InView>
            </div>
          </div>
        </div>

        <WeaponCourseProgram
          data={rf15Course(interfaceLanguage)}
        />

        <ProgramCost
          description={rf15CourseData(interfaceLanguage).description}
          headListData={rf15CourseData(interfaceLanguage).headListData}
          courseOptions={rf15CourseData(interfaceLanguage).courseOptions}
          caption={rf15CourseData(interfaceLanguage).caption}
          otherCurrencyText={rf15CourseData(interfaceLanguage).otherCurrencyText}
          subdescription={rf15CourseData(interfaceLanguage).subdescription}
          emailDescription="Курс RF-15"
        />

        <ContactForm
          emailDescription="Курс RF-15"
        />
      </RF15CourseStyles>
    </>
  );
}

export default RF15Course;
